import { MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import SelectInput from "../../components/TextInput/SelectInput";
import { useForm } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import { notification } from "antd";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useSearchParams } from "react-router-dom";
import EventController from "../Admin/Controller/event_controller.ts";
import { MuiTelInput } from "mui-tel-input";
import { Controller } from "react-hook-form";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { htmlToText } from "html-to-text";
import RowRadioButtonsGroup from "../../components/Radio/RowRadioButtonsGroup.js";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const Register = () => {
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, message) => {
    api[type]({
      message: message,
      description: desc,
    });
  };

  const [searchParams] = useSearchParams();
  const eventID = searchParams.get("eventID");
  const [data, setData] = useState([]); //payment is default during registration eg: registration fee & first year annual subscription fee
  const [nonMemberFee, setNonMemberFee] = useState([]);
  const [RegistrationInfo, setRegistrationInfo] = useState([]);

  useEffect(() => {
    if (eventID) {
      const payload = new FormData();
      payload.append("eventID", eventID); // Append event ID
      EventController.getEventInfo(payload)
        .then((response) => {
          console.log(response)
          const totalBeneficiaries = response.event_registration
          ? response.event_registration.reduce((sum, item_er) => {
              return sum + (item_er.beneficiary?.length || 0);
            }, 0) // Initial value for the accumulator
          : 0;
          console.log(totalBeneficiaries)
          setRegistrationInfo(totalBeneficiaries);
          setData(response);
          setNonMemberFee(response.fees);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [eventID]);

  // console.log(RegistrationInfo)

  //encryptor parameters declaration
  const key = "12345";
  const mode = "YMDHI";
  const Encryptor = new InfinityEncryptor(key, mode); //initialize encyptor

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setError,
    getValues,
    clearErrors,
    watch,
    trigger,
  } = useForm({
    shouldUnregister: false,
    mode: "onChange",
    defaultValues: {
      numberOfPaxHRDClaim: 1,
      numberOfPaxNoHRDClaim: 1,
    },
  });

  const selectedNoOfPaxHRDClaim = watch("numberOfPaxHRDClaim");
  const selectedNoOfPaxNoHRDClaim = watch("numberOfPaxNoHRDClaim");

  const onSubmit = async (data) => {
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }
    console.log(nonMemberFee);

    const formData = new FormData();
    formData.append("eventID", Encryptor.Encrypt(eventID));
    formData.append("nameOfCompany", Encryptor.Encrypt(data.nameOfCompany));
    formData.append("nameOfBuilding", Encryptor.Encrypt(data.nameOfBuilding));
    formData.append("billingAddress", Encryptor.Encrypt(data.billingAddress));
    formData.append(
      "salutationOfContactPerson",
      Encryptor.Encrypt(data.salutationOfContactPerson)
    );
    formData.append(
      "nameOfContactPerson",
      Encryptor.Encrypt(data.nameOfContactPerson)
    );
    formData.append(
      "mobileOfContactPerson",
      Encryptor.Encrypt(data.mobileOfContactPerson)
    );
    formData.append(
      "emailOfContactPerson",
      Encryptor.Encrypt(data.emailOfContactPerson)
    );
    formData.append("hrdCorpGrant", Encryptor.Encrypt(data.hrdCorpGrant));

    const hrdClaimNames = Object.keys(data)
      .filter((key) => key.startsWith("nameOfHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimNRIC = Object.keys(data)
      .filter((key) => key.startsWith("nricOfHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimDesignation = Object.keys(data)
      .filter((key) => key.startsWith("designationOfHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimMobile = Object.keys(data)
      .filter((key) => key.startsWith("mobileOfHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimEmail = Object.keys(data)
      .filter((key) => key.startsWith("emailOfHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimDietaryRestriction = Object.keys(data)
      .filter((key) => key.startsWith("dietaryRestrictionOfHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const hrdClaimStatus = Object.keys(data)
      .filter((key) => key.startsWith("nameOfHRDClaim")) // Get matching keys
      .map(() => "1") // Replace each matched key's value with "1"
      .join(",");

    const noHrdClaimNames = Object.keys(data)
      .filter((key) => key.startsWith("nameOfNoHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimNRIC = Object.keys(data)
      .filter((key) => key.startsWith("nricOfNoHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimDesignation = Object.keys(data)
      .filter((key) => key.startsWith("designationOfNoHRDClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimMobile = Object.keys(data)
      .filter((key) => key.startsWith("mobileOfNoHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimEmail = Object.keys(data)
      .filter((key) => key.startsWith("emailOfNoHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimDietaryRestriction = Object.keys(data)
      .filter((key) => key.startsWith("dietaryRestrictionOfNoHRDCorpClaim")) // Get matching keys
      .map((key) => data[key])
      .join(",");

    const noHrdClaimStatus = Object.keys(data)
      .filter((key) => key.startsWith("nameOfNoHRDClaim")) // Get matching keys
      .map(() => "0") // Replace each matched key's value with "1"
      .join(",");

    const combinedNames = [hrdClaimNames]
      .filter(Boolean)
      .join(",");

    const paxCount = combinedNames
      ? combinedNames.split(",").filter((name) => name.trim() !== "").length
      : 0;

    const combinedNRIC = [hrdClaimNRIC];
    const combinedDesignation = [hrdClaimDesignation];
    const combinedMobile = [hrdClaimMobile];
    const combinedEmail = [hrdClaimEmail];
    const combinedStatus = [hrdClaimStatus];
    const combinedDietaryRestriction = [
      hrdClaimDietaryRestriction
    ];

    formData.append("names", Encryptor.Encrypt(combinedNames));
    formData.append("nric", Encryptor.Encrypt(combinedNRIC));
    formData.append("designation", Encryptor.Encrypt(combinedDesignation));
    formData.append("mobile", Encryptor.Encrypt(combinedMobile));
    formData.append("email", Encryptor.Encrypt(combinedEmail));
    formData.append(
      "dietaryRestriction",
      Encryptor.Encrypt(combinedDietaryRestriction)
    );
    formData.append("HRDClaimstatus", data.hrdCorpGrant);
    formData.append("pax", paxCount);
    formData.append("event_feeID", Encryptor.Encrypt(nonMemberFee.event_feeID));
    formData.append("groupDiscountRate", nonMemberFee.group_discount_rate);
    formData.append("normalRate", nonMemberFee.normal_rate);
    try {
      EventController.registerEventNonMember(formData).then((response) => {
        console.log(response);

        openNotificationWithIcon("success", "Your data has been saved!");
        reset();
        setValueTab(0);
      });
    } catch (error) {
      console.log("Form submission failed: ", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const theme = useTheme();
  const [valueTab, setValueTab] = React.useState(0);

  const handleChangeTab = async (event, newValue) => {
    if (newValue > valueTab) {
      // Prevent moving forward if validation fails
      const isValid = await trigger(["firstField", "secondField"]); // Validate first tab fields
      if (!isValid) return; // Stop tab switch
    }
    setValueTab(newValue); // Allow tab switch only if valid
  };

  const handleClickNext = async () => {
    let fieldsToValidate = [];

    if (valueTab === 0) {
      fieldsToValidate = [
        "eventFees",
        "nameOfCompany",
        "nameOfBuilding",
        "billingAddress",
        "salutationOfContactPerson",
        "nameOfContactPerson",
        "mobileOfContactPerson",
        "emailOfContactPerson",
        // "hrdCorpGrant",
      ];
    } else if (valueTab === 1) {
      fieldsToValidate = ["numberOfPaxHRDClaim"];

      for (let i = 0; i < selectedNoOfPaxHRDClaim; i++) {
        fieldsToValidate.push(
          `nameOfHRDClaim_${i}`,
          `nricOfHRDClaim_${i}`,
          `designationOfHRDClaim_${i}`,
          `mobileOfHRDCorpClaim_${i}`,
          `emailOfHRDCorpClaim_${i}`,
          `dietaryRestrictionOfHRDCorpClaim_${i}`
        );
      }
    } 
    // else if (valueTab === 2) {
    //   fieldsToValidate = ["numberOfPaxNoHRDClaim"];

    //   for (let i = 0; i < selectedNoOfPaxNoHRDClaim; i++) {
    //     fieldsToValidate.push(
    //       `nameOfNoHRDClaim_${i}`,
    //       `nricOfNoHRDClaim_${i}`,
    //       `designationOfNoHRDClaim_${i}`,
    //       `mobileOfNoHRDCorpClaim_${i}`,
    //       `emailOfNoHRDCorpClaim_${i}`
    //     );
    //   }
    // }

    // Validate only the fields from the current tab
    const isValid = await trigger(fieldsToValidate);

    if (!isValid) {
      console.log("Validation failed for:", fieldsToValidate);
      return; // Stop here if validation fails
    }

    setValueTab((prev) => prev + 1); // Move to the next tab
  };

  const handleClickPrev = () => {
    setValueTab((prevValue) => Math.max(prevValue - 1, 0));
  };

  const text_importantNotes = htmlToText(data.important_notes, {
    wordwrap: false,
  });

  return (
    <>
      {contextHolder}

      <Box sx={{ minWidth: 275 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              sx={{ whiteSpace: "pre-line" }}
            >
              {data.event_name}
            </Typography>

            <Typography
              gutterBottom
              variant="h8"
              sx={{ whiteSpace: "pre-line", textAlign:'justify'}}
            >
              {data.event_desc}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {(data?.max_pax !== null &&
        data?.max_pax !== "" &&
        data?.max_pax !== 0 &&
        RegistrationInfo >= data?.max_pax) ||
        (data?.registration_end_date &&
        new Date() > new Date(data.registration_end_date)) ? (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" color="error" sx={{ textAlign: 'center' }}>
              {new Date() > new Date(data?.registration_end_date)
                ? "Registration Ended"
                : "The Registration is Full."}
            </Typography>
          </CardContent>
        </Card>
    ) : (
      <Box sx={{ bgcolor: "background.paper" }}>
        <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            sx={{
              backgroundColor: "#d95252", // Change Tabs background color
              "& .MuiTab-root": {
                color: "white", // Ensure tab text color is always white
                opacity: 1, // Prevent default fading effect
              },
              "& .Mui-selected": {
                backgroundColor: "#d33333", // Change background for selected tab
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "white", // Change the indicator color to white
              },
              "& .Mui-disabled": {
                color: "white !important", // Force white text color for disabled tabs
                opacity: 2, // Ensure no fading
                pointerEvents: "none", // Disable clicks while keeping the style
              },
            }}
          >
            <Tab
              label="ORGANIZATION'S DETAILS"
              {...a11yProps(0)}
              disabled={true}
            />
            <Tab
              label="PARTICIPANTS' DETAILS"
              {...a11yProps(1)}
              disabled={true} // Disable unless the first tab is completed
            />
            {/* <Tab
              label="PARTICIPANTS' DETAILS (NO HRD CLAIMS)"
              {...a11yProps(2)}
              disabled={true} // Disable unless the second tab is completed
            /> */}
            <Tab
              label="IMPORTANT NOTES"
              {...a11yProps(2)}
              disabled={true} // Disable unless the third tab is completed
            />
          </Tabs>
        </AppBar>

        <form
          onSubmit={handleSubmit(onSubmit, onInvalid, {
            shouldFocusError: true,
          })}
        >
          <TabPanel value={valueTab} index={0} dir={theme.direction}>
            <Box sx={{ flexGrow: 1, mt: 2 }}>
              <Grid container spacing={2} mb={4}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    FEES (INCLUSIVE OF SST)
                  </Typography>

                  {/* <RowRadioButtonsGroup
                    {...register("eventFees", {
                      required: "This field is required",
                    })}
                    control={control}
                    passValue={nonMemberFee}
                  /> */}

                  <List>
                    {data.early_bird_start_date === "0000-00-00" ||
                    data.early_bird_start_date === "" ||
                    data.early_bird_start_date === null ||
                    data.early_bird_end_date === "0000-00-00" ||
                    data.early_bird_end_date === "" ||
                    data.early_bird_end_date === null ? (
                      // Show only the normal rate if early bird dates are invalid
                      <>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.normal_rate} (SINGLE)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.group_discount_rate} (FOR GRP OF MIN.
                              {nonMemberFee.min_group_discount_pax} PAX FROM THE SAME COMPANY)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </>
                    ) : (
                      // Show both early bird and normal rates
                      <>
                        <Typography variant="h8" sx={{ fontWeight: "bold" }} gutterBottom>
                          EARLY BIRD ON or BEFORE {data.early_bird_end_date}
                        </Typography>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.early_bird_rate} (SINGLE)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.early_bird_group_discount_rate} (FOR GRP OF
                              MIN.{nonMemberFee.min_group_discount_pax} PAX FROM THE SAME
                              COMPANY)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                        <Typography variant="h8" sx={{ fontWeight: "bold" }} gutterBottom>
                          NORMAL RATE ON or AFTER {data.early_bird_end_date}
                        </Typography>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.normal_rate} (SINGLE)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                        <ListItem>
                          <ListItemText>
                            <Typography variant="h8" gutterBottom>
                              MEMBER RM {nonMemberFee.group_discount_rate} (FOR GRP OF MIN.
                              {nonMemberFee.min_group_discount_pax} PAX FROM THE SAME COMPANY)
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </>
                    )}
                  </List>

                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    NAME OF COMPANY / ORGANISATION
                  </Typography>

                  <TextInput
                    type="text"
                    {...register("nameOfCompany", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors.fees ? errors.fees.message : ""}
                    control={control}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    SHOPPING MALL / BUILDING
                  </Typography>

                  <TextInput
                    type="text"
                    {...register("nameOfBuilding", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.nameOfBuilding ? errors.nameOfBuilding.message : ""
                    }
                    control={control}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    BILLING ADDRESS
                  </Typography>

                  <TextInput
                    type="text"
                    {...register("billingAddress", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.billingAddress ? errors.billingAddress.message : ""
                    }
                    control={control}
                  />
                </Grid>

                <Grid size={{ xs: 3, md: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    SALUTATION
                  </Typography>

                  <TextInput
                    type="text"
                    {...register("salutationOfContactPerson", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.salutationOfContactPerson
                        ? errors.salutationOfContactPerson.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>

                <Grid size={{ xs: 9, md: 9 }}>
                  <Typography variant="h6" gutterBottom>
                    NAME OF CONTACT PERSON
                  </Typography>

                  <TextInput
                    type="text"
                    {...register("nameOfContactPerson", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.nameOfContactPerson
                        ? errors.nameOfContactPerson.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    MOBILE NO. OF CONTACT PERSON
                  </Typography>

                  <Controller
                    name="mobileOfContactPerson"
                    control={control}
                    rules={{ required: "This field is required" }}
                    render={({ field }) => (
                      <MuiTelInput
                        {...field}
                        value={field.value}
                        onChange={field.onChange}
                        defaultCountry="MY"
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            fontSize: "16px",
                            borderRadius: "25px",
                            color: "black",
                            backgroundColor: "white",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#999",
                            },
                          },
                        }}
                        error={Boolean(errors.mobileOfContactPerson)}
                        helperText={
                          errors.mobileOfContactPerson
                            ? errors.mobileOfContactPerson.message
                            : ""
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography variant="h6" gutterBottom>
                    EMAIL ADDRESS OF CONTACT PERSON
                  </Typography>

                  <TextInput
                    type="email"
                    {...register("emailOfContactPerson", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.emailOfContactPerson
                        ? errors.emailOfContactPerson.message
                        : ""
                    }
                    onEmailCheck={(error) => {
                      if (error?.type === "invalidFormat") {
                        setError("emailOfContactPerson", {
                          type: "manual",
                          message: error.message,
                        });
                      } else if (error?.type === "duplicate") {
                        setError("emailOfContactPerson", {
                          type: "manual",
                          message: error.message,
                        });
                      } else if (error?.type === "duplicateInForm") {
                        setError("emailOfContactPerson", {
                          type: "manual",
                          message: error.message,
                        });
                      } else {
                        clearErrors("emailOfContactPerson");
                      }
                    }}
                    control={control}
                    getValues={getValues}
                  />
                </Grid>

                {data.event_categoryID !== 10 && (
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" gutterBottom>
                      ARE YOU APPLYING FOR HRD CORP GRANT?
                    </Typography>

                    <RowRadioButtonsGroup
                      {...register("hrdCorpGrant", {
                        required: "This field is required",
                      })}
                      control={control}
                    />
                  </Grid>
                )}

              </Grid>

              <Grid container spacing={2} mb={4}>
                <Button
                  sx={{ bgcolor: "#d33333" }}
                  variant="contained"
                  onClick={handleClickNext}
                >
                  Next
                </Button>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={valueTab} index={1} dir={theme.direction}>
            <>
              <Grid container spacing={2} mb={4}>
                <Grid size={{ xs: 4, md: 4 }}>
                  <Typography variant="h6" gutterBottom>
                    NUMBER OF PARTICIPANTS
                  </Typography>
                  <TextInput
                    type="number"
                    {...register("numberOfPaxHRDClaim", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.numberOfPaxHRDClaim
                        ? errors.numberOfPaxHRDClaim.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              {Array.from({ length: selectedNoOfPaxHRDClaim }, (_, index) => {
                return (
                  <React.Fragment key={index}>
                    <Grid container spacing={2} mb={8}>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold" }}
                          gutterBottom
                        >
                          Participant Info {index + 1}:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          NAME OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`nameOfHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`nameOfHRDClaim_${index}`]?.message || ""
                          }
                          control={control}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          NRIC OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`nricOfHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`nricOfHRDClaim_${index}`]?.message || ""
                          }
                          control={control}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          DESIGNATION OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`designationOfHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`designationOfHRDClaim_${index}`]?.message ||
                            ""
                          }
                          control={control}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          MOBILE NO. OF PARTICIPANT {index + 1}
                        </Typography>
                        <Controller
                          name={`mobileOfHRDCorpClaim_${index}`}
                          control={control}
                          rules={{ required: "This field is required" }}
                          render={({ field }) => (
                            <MuiTelInput
                              {...field}
                              value={field.value}
                              onChange={field.onChange}
                              defaultCountry="MY"
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "16px",
                                  borderRadius: "25px",
                                  color: "black",
                                  backgroundColor: "white",
                                  "& fieldset": {
                                    borderColor: "#ccc",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#999",
                                  },
                                },
                              }}
                              error={Boolean(
                                errors[`mobileOfHRDCorpClaim_${index}`]
                              )}
                              helperText={
                                errors[`mobileOfHRDCorpClaim_${index}`]
                                  ? errors[`mobileOfHRDCorpClaim_${index}`]
                                      .message
                                  : ""
                              }
                            />
                          )}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          EMAIL ADDRESS OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="email"
                          {...register(`emailOfHRDCorpClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`emailOfHRDCorpClaim_${index}`]?.message ||
                            ""
                          }
                          onEmailCheck={(error) => {
                            if (error?.type === "invalidFormat") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else if (error?.type === "duplicate") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else if (error?.type === "duplicateInForm") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else {
                              clearErrors("emailOfContactPerson");
                            }
                          }}
                          control={control}
                          getValues={getValues}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          DIETARY RESTRICTION OF PARTICIPANT {index + 1}
                        </Typography>
                        <Select
                        className="ep-input form-select"
                          type="text"
                          {...register(
                            `dietaryRestrictionOfHRDCorpClaim_${index}`,
                            {
                              // required: "This field is required",
                            }
                          )}
                          onErrorCheck={
                            errors[`dietaryRestrictionOfHRDCorpClaim_${index}`]
                              ?.message || ""
                          }
                          control={control}
                        >
                          <MenuItem value="0">No Restriction</MenuItem>
                          <MenuItem value="1">Vegetarian</MenuItem>
                          </Select>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                );
              })}

              <Grid container spacing={2} mb={4}>
                <Button
                  sx={{ bgcolor: "#d33333" }}
                  variant="contained"
                  onClick={handleClickPrev}
                >
                  Back
                </Button>
                <Button
                  sx={{ bgcolor: "#d33333" }}
                  variant="contained"
                  onClick={handleClickNext}
                >
                  Next
                </Button>
              </Grid>
            </>
          </TabPanel>
          {/* <TabPanel value={valueTab} index={2} dir={theme.direction}>
            <>
              <Grid container spacing={2} mb={4}>
                <Grid size={{ xs: 4, md: 4 }}>
                  <Typography variant="h6" gutterBottom>
                    NUMBER OF PARTICIPANTS
                  </Typography>
                  <TextInput
                    type="number"
                    {...register("numberOfPaxNoHRDClaim", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.numberOfPaxNoHRDClaim
                        ? errors.numberOfPaxNoHRDClaim.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>
              {Array.from({ length: selectedNoOfPaxNoHRDClaim }, (_, index) => {
                return (
                  <React.Fragment key={index}>
                    <Grid container spacing={2} mb={8}>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold" }}
                          gutterBottom
                        >
                          Participant Info {index + 1}:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          NAME (AS PER IC) OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`nameOfNoHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`nameOfNoHRDClaim_${index}`]?.message || ""
                          }
                          control={control}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          NRIC OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`nricOfNoHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`nricOfNoHRDClaim_${index}`]?.message || ""
                          }
                          control={control}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          DESIGNATION OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="text"
                          {...register(`designationOfNoHRDClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`designationOfNoHRDClaim_${index}`]
                              ?.message || ""
                          }
                          control={control}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          MOBILE NO. OF PARTICIPANT {index + 1}
                        </Typography>
                        <Controller
                          name={`mobileOfNoHRDCorpClaim_${index}`}
                          control={control}
                          rules={{ required: "This field is required" }}
                          render={({ field }) => (
                            <MuiTelInput
                              {...field}
                              value={field.value}
                              onChange={field.onChange}
                              defaultCountry="MY"
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "16px",
                                  borderRadius: "25px",
                                  color: "black",
                                  backgroundColor: "white",
                                  "& fieldset": {
                                    borderColor: "#ccc",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#999",
                                  },
                                },
                              }}
                              error={Boolean(
                                errors[`mobileOfNoHRDCorpClaim_${index}`]
                              )}
                              helperText={
                                errors[`mobileOfNoHRDCorpClaim_${index}`]
                                  ? errors[`mobileOfNoHRDCorpClaim_${index}`]
                                      .message
                                  : ""
                              }
                            />
                          )}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          EMAIL ADDRESS OF PARTICIPANT {index + 1}
                        </Typography>
                        <TextInput
                          type="email"
                          {...register(`emailOfNoHRDCorpClaim_${index}`, {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors[`emailOfNoHRDCorpClaim_${index}`]?.message ||
                            ""
                          }
                          onEmailCheck={(error) => {
                            if (error?.type === "invalidFormat") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else if (error?.type === "duplicate") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else if (error?.type === "duplicateInForm") {
                              setError("emailOfContactPerson", {
                                type: "manual",
                                message: error.message,
                              });
                            } else {
                              clearErrors("emailOfContactPerson");
                            }
                          }}
                          control={control}
                          getValues={getValues}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          DIETARY RESTRICTION OF PARTICIPANT {index + 1}
                        </Typography>
                        <SelectInput
                          type="text"
                          {...register(
                            `dietaryRestrictionOfNoHRDCorpClaim${index}`,
                            {
                              required: "This field is required",
                            }
                          )}
                          onErrorCheck={
                            errors[`dietaryRestrictionOfNoHRDCorpClaim${index}`]
                              ?.message || ""
                          }
                          control={control}
                        />
                      </Grid>
                    </Grid>
                  </React.Fragment>
                );
              })}
              <Grid container spacing={2} mb={4}>
                <Button
                  sx={{ bgcolor: "#d33333" }}
                  variant="contained"
                  onClick={handleClickPrev}
                >
                  Back
                </Button>
                <Button
                  sx={{ bgcolor: "#d33333" }}
                  variant="contained"
                  onClick={handleClickNext}
                >
                  Next
                </Button>
              </Grid>
            </>
          </TabPanel> */}
          <TabPanel value={valueTab} index={2} dir={theme.direction}>
            <Typography component="pre">{text_importantNotes}</Typography>
            <Grid container spacing={2} mb={4}>
              <Button
                sx={{ bgcolor: "#d33333" }}
                variant="contained"
                onClick={handleClickPrev}
              >
                Back
              </Button>

              <Button
                sx={{
                  color: "#d33333",
                  borderColor: "#d33333", // Add border color
                  "&:hover": {
                    backgroundColor: "#d33333", // Change background on hover
                    color: "#fff", // Change text color on hover
                    borderColor: "#d33333",
                  },
                }}
                variant="outlined"
                type="submit"
              >
                Submit
              </Button>
            </Grid>
          </TabPanel>
        </form>
      </Box>
    )}


    </>
  );
};

export default Register;
